import { FC } from 'react';
import { AccessibilityProvider } from '../../context/accessibility/accessibilityContext';
import { PrimaryMenuProps } from './PrimaryMenu.types';
import { StyledPrimaryMenuMobile } from './PrimaryMenu.styled';
import { PrimaryMenuCommon } from './PrimaryMenu';

export const PrimaryMenuMobile: FC<PrimaryMenuProps> = ({ topItems, bottomItems, isDisabled, ...rest }) => (
  <AccessibilityProvider isDisabled={isDisabled}>
    <StyledPrimaryMenuMobile isDisabled={isDisabled} data-test="primary-menu-mobile" aria-disabled={isDisabled} {...rest}>
      <PrimaryMenuCommon topItems={topItems} bottomItems={bottomItems} />
    </StyledPrimaryMenuMobile>
  </AccessibilityProvider>
);
